import httpSchoolClient from '@/plugins/httpSchoolClient';

export default {
  getEntries(state, currentPage) {
    return httpSchoolClient.get(`school/compete/entries/${state}?page=${currentPage}&per_page=10`);
  },
  applyEntry(id) {
    return httpSchoolClient.post(`school/compete/entries/${id}/apply`, {});
  },
  cancelEntry(id) {
    return httpSchoolClient.post(`school/compete/entries/${id}/cancel`, {});
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/schoolApis/compete/entriesApis.js